import { AsyncSearch } from './actionTypes';

const initialState = {
    isFetching: false,
    searchValue: {},
};

const requestAsyncSearch = (state) => {
    return {
        ...state,
        isFetching: true,
    };
};

const receiveAsyncSearch = (state, { searchValue }) => {
    return {
        ...state,
        isFetching: false,
        searchValue,
    };
};

export default function(state = initialState, action) {
    switch (action.type) {
        case AsyncSearch.REQUEST_ASYNC_SEARCH:
            return requestAsyncSearch(state);
        case AsyncSearch.RECEIVE_ASYNC_SEARCH:
            return receiveAsyncSearch(state, action);
    }
    return state;
}
